export function rgbCss(rgb, alpha = 1) {
    if (alpha >= 1) {
        return `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;
    }
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
}
